export const OTT_LOGO = require("./ott.png");
export const OTT_WHITE_LOGO = require("./white-logo.png");
export const OTT_GREEN_LOGO = require("./green-logo.png");
export const OTT_PINK_LOGO = require("./pink-logo.png");
